import Papa from 'papaparse'

async function fetchPaginated(url: string) {
  async function getNextPage(
    url: string,
    content: (string | null | undefined)[] = [],
  ) {
    const response = await fetch(url)
    const text = await response.text()
    const markup = new DOMParser().parseFromString(text, 'text/html')
    const newContent = markup.querySelector('#content')?.textContent
    const nextPageLink = markup.querySelector('#next_page') as HTMLAnchorElement

    const c = [...content, newContent].filter(Boolean)

    if (!nextPageLink?.href) {
      return c
    } else {
      const nextUrl = new URL(url, window.location.origin)
      const nextPageParam = new URL(nextPageLink.href, window.location.origin)
      const param = [...nextPageParam.searchParams.entries()].flat()
      nextUrl.searchParams.set(param[0], param[1])

      return await getNextPage(nextUrl.toString(), c)
    }
  }

  return await getNextPage(url)
}

export async function fetchPaginatedCSV(url: string) {
  return fetchPaginated(url).then((csvPages) =>
    csvPages
      .map((page) => {
        if (!page) return

        return Papa.parse(page, {
          delimiter: ',',
          header: true,
          skipEmptyLines: true,
          transformHeader: (h: string) => h.trim(),
        })
      })
      .filter(Boolean)
      .map((page) => page?.data)
      .flat(),
  )
}
